<div class="fixed top-5 right-1/2 translate-x-1/2 space-y-3 z-[9999999]">
  @for(notification of notificationService.notifications(); track notification.id) {
  <div class="px-4 py-2 rounded-md shadow-lg flex items-center justify-between min-w-80 max-w-lg bg-black/80 text-sm">
    <div class="flex items-center">
      @if(notification.type === 'success') {
      <svg width="24" height="24" viewBox="0 0 24 24" class="mr-2 text-green-500">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
          fill="currentColor" />
      </svg>
      } @else if(notification.type === 'error'){
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-2 text-red-500 w-8">
        <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor" />
      </svg>
      } @else if(notification.type === 'warning') {
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-2 text-orange-500">
        <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor" />
      </svg>
      } @else {
      <svg width="24" height="24" viewBox="0 0 24 24" class="mr-2 text-blue-500">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17H13V15H11V17ZM11 13H13V7H11V13Z"
          fill="currentColor" />
      </svg>
      }
      <span class="text-white tracking-wider">{{ notification.message }}</span>
    </div>
    <!-- <button class="ml-4 text-white cursor-pointer rounded-lg aspect-square w-8 text-[10px] pointer-events-auto"
      (click)="notificationService.dismiss(notification.id)">✖</button> -->
  </div>
  }
</div>